import React, { useEffect, useState } from 'react'

import global from 'common'

import { AdminTaskResponse } from 'core'
import { AdminTask, TaskStatus } from 'core/application/adminDashboard/adminTasks'

import SetupHeader from './SetupHeader'
import SetupProgress from './SetupProgress'
import SetupProgressSteps from './SetupProgressSteps'

import './styles.less'

type AdminTasksStepsProps = {
  taskIsLoading?: (taskId: number) => boolean
  tasks: AdminTask[] | AdminTaskResponse[]
  headerAlert?: React.ReactNode
  onTaskClicked?: (taskId: number) => void
}

const AdminTasksSteps = (props: AdminTasksStepsProps) => {
  const [user] = global.hooks.useLoginUser()
  const [activeStepIndex, setActiveStepIndex] = useState<number>(0)

  useEffect(() => {
    setActiveStepIndex(props.tasks.findIndex((x) => x.status == TaskStatus.Active))
  }, [props.tasks])

  return (
    <>
      <div className="container-100-percent bg-white flex fd-col mt-32 inner-padding" style={{ maxWidth: 700 }}>
        <div className="main-wrapper inner-padding flex flex__column">
          {props.tasks.length > 0 && (
            <>
              <SetupHeader user={user} />
              {props.headerAlert}
              <SetupProgress steps={props.tasks} activeStep={activeStepIndex} />
              <SetupProgressSteps
                isLoading={(taskId) => props.taskIsLoading(taskId)}
                steps={props.tasks}
                activeStep={activeStepIndex}
                onStepClick={(taskId) => {
                  if (props.onTaskClicked) {
                    props.onTaskClicked(taskId)
                  }
                }}
              />
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default AdminTasksSteps
